import { render } from "./index.vue?vue&type=template&id=32b7e99a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32b7e99a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b7e99a"],['__file',"src/views/game/team/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32b7e99a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32b7e99a', __exports__)) {
    console.log('reload')
    api.reload('32b7e99a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=32b7e99a&scoped=true", () => {
    console.log('re-render')
    api.rerender('32b7e99a', render)
  })

}


export default __exports__